import * as NavConstants from 'constants/NavConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {Optional} from 'util/Types';

import type {ChatDraftState} from '../ChatDraftState';
import type {InitialUI} from './AISidepanelV2GlobalClientState';

export const ENTRY_FROM_COMPOSE_PROMPT =
  'Help me draft an entry. Ask me one or two questions to get started.';

function getClientStateModule(): {
  openExistingChat: (chatSessionId: string) => void;
  openDraftChat: (draftState: ChatDraftState, options: {initialUI?: Optional<InitialUI>}) => void;
} {
  // This avoids a circular dependency in react-render.bundle.js.
  return require('./AISidepanelV2GlobalClientState');
}

export function openChat(chatSessionId: string): void {
  // This avoids a circular dependency in react-render.bundle.js.
  const SidepanelActions = require('nav/sidepanel/SidepanelActions');
  getClientStateModule().openExistingChat(chatSessionId);
  SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
}

export function openDraftChat(
  draftState: ChatDraftState,
  options: {initialUI?: Optional<InitialUI>} = {}
): void {
  getClientStateModule().openDraftChat(draftState, options);
}

export function openDraftChatInSidepanel(
  agentType: AgentType,
  initialPrompt: string = '',
  contextIds?: Array<string>,
  originSearchQuery?: string
): void {
  const {makeNewDraftState} = require('../ChatDraftState');
  const SidepanelActions = require('nav/sidepanel/SidepanelActions');
  getClientStateModule().openDraftChat(
    makeNewDraftState(agentType, initialPrompt, {contextIds, originSearchQuery}),
    {}
  );
  SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
}
